/**
 * Features related to location
 * @module services/location
 */
import { Map } from 'immutable'
import get from 'lodash/get'
import { parse } from 'url'
import { stringify as stringifyQs } from '../query-string'

/**
 * Parse a location href into a URL object
 * @param {Object} location The window location object
 * @param {String} location.href The window location href string to parse
 * @return An object with the location properties
 */
export function parseWindowLocationHref (location) {
  return parse(get(location, 'href', ''), true)
}

/**
 * Parse an Immutable location object from a Redux store into a href
 * string for navigation
 */
export function createLocationHref (location, queryStringOptions = { arrayFormat: 'bracket' }) {
  const pathname = location.getIn(['data', 'pathname'])
  const query = location.getIn(['data', 'query'], Map()).toJS()
  const queryString = stringifyQs(query, queryStringOptions)
  return `${pathname}${queryString ? '?' : ''}${queryString}`
}

/**
 * Get the location query given the location redux state
 * @param {Map} location The location state
 * @returns {Map} The query or a Map if undefined
 */
export function getLocationQuery (location) {
  if (!Map.isMap(location)) {
    throw new Error('The location argument is required to be a Map')
  }
  return location.getIn(['data', 'query']) || Map()
}

/**
 * Get the location pathname given the location redux state
 * @param {Map} location The location state
 * @returns {String} The pathname or undefined
 */
export function getLocationPathname (location) {
  if (!Map.isMap(location)) {
    throw new Error('The location argument is required to be a Map')
  }
  return location.getIn(['data', 'pathname'], '')
}
